'use client';

import { IcChevronUp, theme } from '@bgzt/ui';
import { useState } from 'react';
import { FloatingArea } from '~/components';
import { useEventListener } from '@bgzt/hooks';
import styles from './ScrollToTopButton.module.css';
import { motion } from 'motion/react';

type Props = {
  bottom?: number;
};

export const ScrollToTopButton = ({ bottom = 10 }: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => setIsVisible(globalThis.window.scrollY > 100);

  const scrollToTop = () => globalThis.window.scrollTo({ top: 0, behavior: 'smooth' });

  useEventListener(globalThis.window, 'scroll', toggleVisibility);

  return (
    <FloatingArea right={20} bottom={bottom}>
      <motion.div
        animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }} // Move to original position and fully opaque
        transition={{ duration: 0.1 }} // Customize duration and easing
      >
        <button onClick={scrollToTop} className={styles.button}>
          <IcChevronUp size={16} fill={theme.colors['gray-900']} />
        </button>
      </motion.div>
    </FloatingArea>
  );
};
